import { cn } from 'app/lib/utils'

export function StatTile({
  label,
  tint,
  className,
  wrap,
  children,
}: {
  label: string
  tint?: `green`
  className?: string
  /** Allow multi-chip content to wrap instead of single-line truncating. */
  wrap?: boolean
  children?: React.ReactNode
}) {
  if (children == null) return null
  return (
    <div
      className={cn(
        `min-w-0 rounded-lg px-3 py-2.5`,
        tint === `green` ? `bg-green-500/8` : `bg-surface-subtle`,
        className,
      )}
    >
      <p
        className={cn(
          `truncate text-label-xs uppercase tracking-wide`,
          tint === `green` ? `text-green-700/70` : `text-subtle`,
        )}
      >
        {label}
      </p>
      {/* One content size for every tile: a plain value and an editable chip
          sit side by side, so they have to read as the same class of thing. */}
      <div className="mt-1 flex min-h-7 min-w-0 items-center">
        <span className={cn(`min-w-0 text-body-sm text-strong`, wrap ? `w-full` : `truncate`)}>{children}</span>
      </div>
    </div>
  )
}
